"use client";

import Link from "next/link";

import { Logo } from "@/components/logo";
import { withNext } from "@/lib/auth/safe-next";
import { onboardingUrl } from "@/lib/onboarding/routes";

import type { StepProps } from "../types";
import { ContinueButton, StepFooter, StepHeader } from "../ui";

/** The cold open: the very first screen, rendered without back/progress
 *  chrome. Profession-neutral, since the profession isn't known yet. */
export function HookStep({ env, advance }: StepProps) {
  return (
    <>
      <div className="flex items-center gap-2.5 md:hidden">
        <Logo size={40} />
        <span className="text-lg font-semibold tracking-tight text-foreground">
          Medceptor
        </span>
      </div>
      <div className="mt-16 sm:mt-24">
        <StepHeader
          kicker="Be honest"
          title="You know the material. Test day is a different animal."
          body="Reading isn't the same as doing it out loud, with a clock running and someone grading every step."
        />
      </div>
      <StepFooter>
        <ContinueButton onClick={() => advance()}>That&apos;s me</ContinueButton>
        {!env.authed ? (
          <p className="py-3 text-center text-sm text-muted-foreground">
            Already have an account?{" "}
            <Link
              href={withNext("/login", onboardingUrl(env.next))}
              // inline-block + py-3/-my-3 grows the tap target to ~44px
              // without changing the line's layout.
              className="-my-3 inline-block py-3 text-primary underline"
            >
              Sign in
            </Link>
          </p>
        ) : null}
      </StepFooter>
    </>
  );
}
